export function SET_CASHBOX(payload) {
	return {
		type: 'SET_CASHBOX',
		payload: payload,
	};
}